const ANGELS = [
  {
    image: `/static/about/investors/angels/guillermo.png`,
    name: `Guillermo Rauch`,
    title: `CEO, Vercel`,
  },
  {
    image: `/static/about/investors/angels/calvin.png`,
    name: `Calvin French-Owen`,
    title: `Co-founder, Segment`,
  },
  {
    image: `/static/about/investors/angels/max.png`,
    name: `Max Mullen`,
    title: `Co-founder, Instacart`,
  },
  {
    image: `/static/about/investors/angels/naval.png`,
    name: `Naval Ravikant`,
    title: `Co-founder, AngelList`,
  },
  {
    image: `/static/about/investors/angels/oliverjay.png`,
    name: `Oliver Jay`,
    title: `Head of Revenue, Asana`,
  },
  {
    image: `/static/about/investors/angels/rafael.jpg`,
    name: `Rafael Corrales`,
    title: `Background.vc`,
  },
  {
    image: `/static/about/investors/angels/michelle.jpg`,
    name: `Michelle Valentine`,
    title: `Co-founder, Anrok`,
  },
  {
    image: `/static/about/investors/angels/brianne.jpg`,
    name: `Brianne Kimmel`,
    title: `Worklife.vc`,
  },
  {
    image: `/static/about/investors/angels/chris.jpg`,
    name: `Chris Nguyen`,
    title: `Co-founder, LogDNA`,
  },
  {
    image: `/static/about/investors/angels/nilam.jpg`,
    name: `Nilam Ganenthiran`,
    title: `D1 Capital`,
  },
  {
    image: `/static/about/investors/angels/immad.png`,
    name: `Immad Akhund`,
    title: `CEO, Mercury`,
  },
  {
    image: `/static/about/investors/angels/jeff.jpg`,
    name: `Jeff Chang`,
    title: `Head of Growth, Whatnot`,
  },
  {
    image: `/static/about/investors/angels/kevin.jpg`,
    name: `Kevin Henrikson`,
    title: `VP Engineering, Instacart`,
  },
];

export default ANGELS;
